const get = require('lodash').get;

const  getStripePublicKey = (country, stripeKeys) => {
  let stripePublicKey = '';
  switch (country.toLowerCase()) {
  case 'us':
    stripePublicKey = 'stripe_us_public_key';
    break;
  case 'gb':
    stripePublicKey = 'stripe_uk_public_key';
    break;
  case 'au':
    stripePublicKey = 'stripe_au_public_key';
    break;
  case 'ca':
    stripePublicKey = 'stripe_ca_public_key';
    break;
  case 'de':
  case 'fr':
  case 'es':
    stripePublicKey = 'stripe_eu_public_key';
    break;
  default:
    stripePublicKey = 'stripe_public_key';
  }

  return get(stripeKeys, stripePublicKey);
}
exports.getStripePublicKey = getStripePublicKey;
